import React from "react";
import { Form, Empty } from "antd";
import { renderFieldFormItem } from "../help";
import styles from "../index.module.less";

interface FlatDomainFormProps {
    flatNodes: any[];
    form: any;
    handleFormValuesChange: (changedFields: any, allFields: any) => void;
    handleSearch: (item: any) => void;
}

export default function FlatDomainForm({ 
    flatNodes, 
    form, 
    handleFormValuesChange, 
    handleSearch 
}: FlatDomainFormProps) {
    return (
        <div className={styles.formContainer}>
            {flatNodes?.length > 0 ? (
                <Form 
                    size="small" 
                    form={form} 
                    onValuesChange={handleFormValuesChange} 
                    layout="vertical"
                >
                    {flatNodes.map((item) => (
                        <Form.Item
                            key={item.key}
                            name={item.fieldTag}
                            label={item.fieldName}
                            rules={[]}
                        >
                            {renderFieldFormItem(item, false, handleSearch)}
                        </Form.Item>
                    ))}
                </Form>
            ) : (
                <div className={styles.emptyContainer}>
                    <Empty description="当前文档未引用字段域" />
                </div>
            )}
        </div>
    );
}